import { useState, useEffect, useContext } from "react";
import { useEffectOnce } from "../hooks/useEffectOnce";
import cookies from "js-cookie";
import i18next from "i18next";
import { Globe } from "lucide-react";
import { useTranslation } from "react-i18next";
import {
    DropdownMenu,
    DropdownMenuTrigger,
    DropdownMenuItem,
    DropdownMenuContent,
  } from "./ui/dropdown-menu";
import { directionService } from "../services/directionService";
import LoggerContext from "../context/LoggerProvider";
  
const availableLanguages = [
    {
      code: "he",
      name: "עברית",
      country_code: "il",
      dir: "rtl",
    },
    {
      code: "en",
      name: "English",
      country_code: "gb",
    },
    {
      code: "de",
      name: "Deutsch",
      country_code: "de",
    },
];

function Localize() {
    const { t } = useTranslation();
    const { Logger } = useContext(LoggerContext);

    const [currentLanguageCode, setCurrentLanguageCode] = useState("");
    const [currentLanguage, setCurrentLanguage] = useState({});
    const [previousLanguage, setPreviousLanguage] = useState({});
  
    const selectLanguage = (code) => {
        i18next.changeLanguage(code);
        setCurrentLanguageCode(code);
    };

    const showLocale = (ts) => {
        return new Date(ts).toLocaleString(
        cookies.get("i18next")?.split("-")[0] || "en"
        );
    };
    
    useEffectOnce(() => {
        setCurrentLanguageCode(cookies.get("i18next")?.split("-")[0] || "en");
        Logger.debug(
            "currentLanguageCode has been set to " +
            (cookies.get("i18next")?.split("-")[0] || "en")
        );    
    }, []);

  useEffect(() => {
    document.body.dir = currentLanguage?.dir || "ltr";
    Logger.info("body.dir has been set to " + (currentLanguage?.dir || "ltr"));

    // register change of RTL<->LTR
    if (previousLanguage?.dir !== currentLanguage?.dir) {
      Logger.debug(
        "Script direction change detected, forwarding to design view if necessary"
      );
      directionService.sendDirectionChange();
    }
    setPreviousLanguage(currentLanguage);
  }, [currentLanguage]);

  useEffect(() => {
    let newLanguage = availableLanguages.find(
      (l) => l.code === currentLanguageCode
    );

    setCurrentLanguage(newLanguage);
    Logger.debug("currentLanguage has been set");
  }, [currentLanguageCode]);

    return <>
    <DropdownMenu>
        <DropdownMenuTrigger className="bg-transparent ms-2">
            <Globe />
        </DropdownMenuTrigger>
        <DropdownMenuContent>
            {availableLanguages.map((lang, idx) => (
            <DropdownMenuItem
                key={idx}
                onClick={() => selectLanguage(lang.code)}
            >
                <span
                className={`flag-icon mx-2 flag-icon-${lang.country_code}`}
                />
                {lang.name}
            </DropdownMenuItem>
            ))}
        </DropdownMenuContent>
    </DropdownMenu>
    </>
}

export default Localize;
